<ion-header>

  <!-- Main toolbar -->
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" (click)="navCtrl.back()"></ion-back-button>
    </ion-buttons>
    <ion-title *ngIf="mode == modeValue.DEFAULT" class="text-large text-center ion-text-bold" >
      {{ 'NEARBYEVENT_PARTICIPANTS_TITLE' | translate }}
    </ion-title>
    <ion-title *ngIf="mode == modeValue.LOCATION_EXPORT" class="text-large text-centerion-text-bold" >
      {{ 'TRACK_FRIENDS' | translate }}
    </ion-title>

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="openSettingsPage()">
        <ion-icon slot="icon-only" name="settings"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <!-- Search toolbar -->
  <ion-toolbar>
    <ion-searchbar
      type="text"
      (ionInput)="autocompleteKeyUp($event)"
      placeholder="{{ 'NEARBYEVENT_PARTICIPANT_SEARCH_NAME_FIELD' | translate }}"
      animated="true">
    </ion-searchbar>

    <ion-buttons slot="end" *ngIf="mode == modeValue.LOCATION_EXPORT && autoCompleteList.length">
      <ion-button fill="clear" (click)="onLocationExportChange()">
        <ion-icon *ngIf="!trackingService.options.locationExport" slot="icon-only" name="play"></ion-icon>
        <ion-icon *ngIf="trackingService.options.locationExport" slot="icon-only" name="ios-square-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>



<ion-content [fullscreen]="true">
  <ion-list class="ion-no-padding">
    <ion-item *ngFor="let profile of friends" (click)="autoCompleteSelect(profile)" class="friend-list">
      <ion-icon slot="start" name="add-circle-outline" color="dark"></ion-icon>
      <h2>{{profile.userName}}</h2>
    </ion-item>
    <ion-item *ngFor="let participant of autoCompleteList" (click)="autoCompleteSelect(participant)" class="friend-list">
      <ion-icon slot="start" name="add-circle-outline" color="dark"></ion-icon>
      <h2>{{participant.firstName}} {{participant.lastName}}</h2>
    </ion-item>
  </ion-list>

  <ion-list class="ion-no-padding">
    <!-- ITEM TEMPLATE -->
    <!-- <ion-item-sliding animated *ngFor="let participant of activeItem.participants">
      <ion-item class="result-header">
        <ion-avatar item-start>
          <img src="{{participant.img}}">
        </ion-avatar>
        <span inline-block>
          <h2 *ngIf="!participant?.userName" class="ion-text-ellipsis ion-text-bold">{{participant.firstName}} {{participant.lastName}}
          </h2>
          <h2 *ngIf="participant?.userName" class="ion-text-ellipsis ion-text-bold">{{participant?.userName}}
          </h2>
        </span>
      </ion-item>
      <ion-item-options side="end">
        <ion-button color="danger" fill="solid" (click)="remove(participant)">
          <ion-icon slot="start" name="trash"></ion-icon>
          {{ 'NO_TRACKING' | translate }}
        </ion-button>
      </ion-item-options>
    </ion-item-sliding> -->
    <ion-item-sliding *ngFor="let participant of activeItem.participants">    
      <ion-item>
        <ion-avatar slot="start">
          <img [src]="participant.img" />
        </ion-avatar>
          
        <ion-label>
          <h2 *ngIf="!participant?.userName" class="ion-text-wrap ion-text-bold">
            {{ participant.firstName }} {{ participant.lastName }}
          </h2>
          <h2 *ngIf="participant?.userName" class="ion-text-wrap ion-text-bold">
            {{ participant.userName }}
          </h2>
        </ion-label>
      </ion-item>

      <ion-item-options side="end">
        <ion-item-option  (click)="remove(participant)">
            <ion-icon slot="start" name="trash" color="danger"></ion-icon>
            <span>{{ 'NO_TRACKING' | translate }}</span>
        </ion-item-option>
      </ion-item-options>
    </ion-item-sliding>

    <!-- END ITEM TEMPLATE -->
  </ion-list>

  <div *ngIf="!activeItem || activeItem.participants.length === 0">
    <p class="ion-text-small text-center" *ngIf="mode == modeValue.DEFAULT">
      <strong>{{'NEARBYEVENT_PARTICIPANTS_TIP_1' | translate}} <br />
        {{'NEARBYEVENT_PARTICIPANTS_TIP_2' | translate}}
      </strong>
    </p>
    <p class="ion-text-small text-center" *ngIf="mode == modeValue.LOCATION_EXPORT">
      <strong>{{'ENTER_FRIENDS_NAME_MSG' | translate}}</strong>
    </p>
  </div>

  <div *ngIf="!autoCompleteList.length && mode == modeValue.LOCATION_EXPORT" class="block-button"
    (click)="onLocationExportChange()">
    <ion-button class="btn-circle button-circle" fill="outline">
      <ion-icon 
        *ngIf="!trackingService.options.locationExport" 
        name="play" 
        slot="icon-only" 
        style="padding-left: 5px;">
      </ion-icon>

      <ion-icon 
        *ngIf="trackingService.options.locationExport" 
        name="square-outline" 
        slot="icon-only">
      </ion-icon>
    </ion-button>
    <p>
      <strong *ngIf="!trackingService.options.locationExport">
        {{ 'SHARE_POSITION' | translate}}
      </strong>
      <strong *ngIf="trackingService.options.locationExport">
        {{ 'STOP_SHARE_POSITION' | translate}}
      </strong>
    </p>
  </div>

</ion-content>